import { render, staticRenderFns } from "./MultistepBeneficiary.vue?vue&type=template&id=4f92cb98"
import script from "./MultistepBeneficiary.vue?vue&type=script&lang=js"
export * from "./MultistepBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports